/**
 * Block grouping for the public render — the SINGLE SOURCE shared by the Nuxt
 * site's `BlockRenderer.vue` and the admin builder's live canvas
 * (`admin/src/components/builder/CanvasBlocks.vue`), so both sides group
 * consecutive blocks identically and the preview can never drift from the site.
 * Pure functions, no framework deps (importable from either build).
 */

// Collapses consecutive media_article / contact blocks into one section each so
// they render as a grid instead of as stacked, half-empty cards. Everything else
// stays a "single" run of one block. Order is preserved.
export function groupBlocks(blocks) {
  const out = [];
  for (const b of blocks) {
    const kind =
      b.type === "media_article" ? "articles"
      : b.type === "contact"       ? "contacts"
      : "single";
    const last = out[out.length - 1];
    if (last && last.kind === kind && kind !== "single") {
      last.items.push(b);
    } else {
      out.push({ kind, items: [b] });
    }
  }
  return out;
}

// Within an articles section, split into runs of consecutive articles that share
// the same `event` label so each event gets its own titled sub-grid. Articles
// with no event fall into an untitled run.
export function groupByEvent(items) {
  const out = [];
  for (const b of items) {
    const event = ((b.data?.event) || "").trim();
    const last = out[out.length - 1];
    if (last && last.event === event) {
      last.items.push(b);
    } else {
      out.push({ event, items: [b] });
    }
  }
  return out;
}
